import React, { useState, useEffect } from "react";
import tag from "../../assets/images/chats/tag.png";
import menuIcon from "../../assets/images/DeathModuleNew/Menu.png";
import setting from "../../assets/SVGs/setting.svg";
import { setActiveStep } from "../../redux/slices/loginSlice";
import { useDispatch } from "react-redux";
// import { ConnectAccount } from "./ConnectAccount";
import "./contacts.css";
import { ViewClientContacts } from "./ViewClientContacts";
import { UpdateClinetContacts } from "./UpdateClinetContacts";
import axios from "axios";
import DEATH_API from "../../apis/death.api";
import ConnectAccount from "./ConnectAccount";
import { Table,Modal } from "antd";
import { Menu, Dropdown, Icon } from 'antd';
import swal from "sweetalert";
import { AddContacts } from "./AddContacts";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useHistory, useLocation } from "react-router-dom";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";
import ModalVideo from "../ModuleVideos/ModalVideo";

const SidebarListSkeleton = ({ rows = 5, showSearch = true, compact = false }) => (
  <div className="sidebarSkeleton">
    {showSearch && <div className="sidebarSkeletonSearch shimmerSkeleton" />}
    <div className="sidebarSkeletonList">
      {Array.from({ length: rows }).map((_, index) => (
        <div
          key={`sidebar-skeleton-${index}`}
          className={`sidebarSkeletonRow ${compact ? "sidebarSkeletonRowCompact" : ""}`}
        >
          <div className="sidebarSkeletonAvatar shimmerSkeleton" />
          <div className="sidebarSkeletonContent">
            <div className="sidebarSkeletonLine sidebarSkeletonLinePrimary shimmerSkeleton" />
            <div className="sidebarSkeletonLine sidebarSkeletonLineSecondary shimmerSkeleton" />
          </div>
          <div className="sidebarSkeletonAction shimmerSkeleton" />
        </div>
      ))}
    </div>
  </div>
);

export const ClientPlan = () => {
  const [selectedContact, setSelectedContact] = useState(null);
  const [contactdropdown, setContactDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [loading, setLoading] = useState(false);
  const [loadingContent, setLoadingContent] = useState({
    title: "Working on your contacts...",
    subtext: "Please wait while we complete this action.",
  });
  const [initialContactsLoading, setInitialContactsLoading] = useState(true);
  const [initialGroupsLoading, setInitialGroupsLoading] = useState(true);
  const [importContacts, setImportContacts] = useState(false);
  const [viewContacts, setViewContacts] = useState(false);
  const [editContacts, setEditContacts] = useState(false);
  const [clientContacts, setClientContacts] = useState([]);
  const [manageContact, setManageContact] = useState(null);
  const [addContact,setAddContact]= useState(false);
  const [addEmailTemplate, setAddEmailTemplate] = useState(false);
  const [emailTemplateData, setEmailTemplateData] = useState({});
  const [addTextTemplate, setAddTextTemplate] = useState(false);
  const [textTemplateData, setTextTemplateData] = useState({});
  const [searchGroupContacts, setSearchGroupContacts] = useState(""); 
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const beginLoading = (title, subtext) => {
    setLoadingContent({ title, subtext });
    setLoading(true);
  };

  const closeEmailTemplateModal = () => {
    setAddEmailTemplate(false);
  };
  const saveEmailTemplateModal = async () => {
    setAddEmailTemplate(false);

   console.log("emailtemlte data",emailTemplateData)
   let payload={
    ...emailTemplateData,
    type:"email",
  }
  try {
    beginLoading("Sending email...", "Please wait while we send the email template to this group.");
    let apiResponse = await DEATH_API.sendEmailsToGroup(selectedGroupIndex,payload);
    console.log("apiResponse", apiResponse);
    if (apiResponse && apiResponse.status===200) {
     swal("Success", apiResponse.message, "success");
    }
    setLoading(false);
  } catch (error) {
    console.log(error);
    setLoading(false);
  }

   setEmailTemplateData({});
  };

  const closeTextTemplateModal = () => {
    setAddTextTemplate(false);
  };
  const saveTextTemplateModal = async () => {
    setAddTextTemplate(false);
    console.log("textTemplateData",textTemplateData,selectedGroupIndex);
    let payload={
      ...textTemplateData,
      type:"text",
    }
    try {
      beginLoading("Sending text...", "Please wait while we send the text template to this group.");
      let apiResponse = await DEATH_API.sendEmailsToGroup(selectedGroupIndex,payload);
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.status===200) {
        swal("Success", apiResponse.message, "success");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  
    setTextTemplateData({});
  };
  // checkboxes
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => {
    setIsModalOpen(false);
    // setSelectedCheckContacts([]);
  };
  const openModal = () => {
    setIsModalOpen(true);
  };

  const [selectedCheckContacts, setSelectedCheckContacts] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const handleCheckboxChange = (contactId) => {
    if (selectedCheckContacts.includes(contactId)) {
      setSelectedCheckContacts(selectedCheckContacts.filter((id) => id !== contactId));
    } else {
      setSelectedCheckContacts([...selectedCheckContacts, contactId]);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedCheckContacts([]);
    } else {
      setSelectedCheckContacts(filteredContacts.map((contact) => contact.id));
    }
    setSelectAll(!selectAll);
  };


  // add groups
  const [groupName, setGroupName] = useState('');
  const [groupNameEdit, setGroupNameEdit] = useState('');
  const [allGroups, setAllGroups] = useState([]);

  const [addGroup, setAddGroup] = useState(false);
  const [groupDropdown, setGroupDropdown] = useState(false);
  const [selectedGroupIndex, setSelectedGroupIndex] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [editGroup, setEditGroup] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState([]);
  // const handleCheckboxChange = (contactId) => {
  //   // Check if the contact is already selected
  //   const index = selectedContacts.indexOf(contactId);
  //   if (index === -1) {
  //     // If not selected, add it to the array
  //     setSelectedContacts([...selectedContacts, contactId]);
  //   } else {
  //     // If already selected, remove it from the array
  //     const updatedContacts = [...selectedContacts];
  //     updatedContacts.splice(index, 1);
  //     setSelectedContacts(updatedContacts);
  //   }
  // };
  const convertToCSV = () => {
    // Filter out keys to exclude from export
    const excludedKeys = ["deleted", "clientId","enable","cloud_contact_details","id"];
    
    // Get the headers excluding excluded keys
    const headers = Object.keys(clientContacts[0])
      .filter(key => !excludedKeys.includes(key))
      .join(',');
  
    // Convert data to CSV, excluding excluded keys
    const csvData = clientContacts.map(item =>
      Object.keys(item)
        .filter(key => !excludedKeys.includes(key))
        .map(key => item[key])
        .join(',')
    ).join('\n');
  
    return `${headers}\n${csvData}`;
  };

  const downloadCSV = () => {
    const csvData = convertToCSV();
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'cloudContacts.csv');
    document.body.appendChild(link);
    link.click();
  };
  const convertSelectedToCSV = () => {
    // Filter out keys to exclude from export
    const excludedKeys = ["deleted", "clientId", "enable","cloud_contact_details","id"];
    
    // Get the headers excluding excluded keys
    const headers = Object.keys(clientContacts[0])
      .filter(key => !excludedKeys.includes(key))
      .join(',');
  
    // Filter clientContacts to include only selected contacts
    const selectedContacts = clientContacts.filter(item => selectedCheckContacts.includes(item.id));
  
    // Convert selected contacts to CSV, excluding excluded keys
    const csvData = selectedContacts.map(item =>
      Object.keys(item)
        .filter(key => !excludedKeys.includes(key))
        .map(key => item[key])
        .join(',')
    ).join('\n');
  
    return `${headers}\n${csvData}`;
  };
  
  const downloadSelectedCSV = () => {
    const csvData = convertSelectedToCSV();
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'selectedContacts.csv');
    document.body.appendChild(link);
    link.click();
    setSelectAll(false);
    setSelectedCheckContacts([]);
  };
  
  const deleteSelectCloudContact = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete these Contacts?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          beginLoading("Deleting contacts...", "Please wait while we remove the selected contacts.");
          await DEATH_API.DeleteSelectedContacts(selectedCheckContacts);
          setLoading(false);
          await getContacts();
          await getGroups();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Deleted!", "Your Contacts has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Contacts are safe :)", "error");
      }
    });
    setSelectAll(false);
    setSelectedCheckContacts([]);
  };

  // const sortBy = (key) => {
  //   // Create a copy of the contacts array to avoid mutating the state directly
  //   const sortedContacts = [...clientContacts];

  //   // Sort the contacts array based on the provided key
  //   sortedContacts.sort((a, b) => {
  //     // Handle sorting by name
  //     if (key === 'name') {
  //       // Add null checks for name properties
  //       if (a.name && b.name) {
  //         return a.name.localeCompare(b.name);
  //       }
  //       // If either name is null, prioritize sorting by other criteria
  //       return 0;
  //     }
  //     // Handle sorting by phone number
  //     if (key === 'phoneNumber') {
  //     // Add null check for phoneNumber property
  //     if (a.phoneNumber && b.phoneNumber) {
  //       return a.phoneNumber.localeCompare(b.phoneNumber);
  //     }
  //     // If either phoneNumber is null, prioritize sorting by other criteria
  //     return 0;
  //       // return a.phoneNumber.localeCompare(b.phoneNumber);
  //     }
  //   });

  //   // Update the state with the sorted contacts array
  //   setClientContacts(sortedContacts);
  // };
  const sortBy = (key) => {
    // Create a copy of the contacts array to avoid mutating the state directly
    const sortedContacts = [...clientContacts];
  
    sortedContacts.sort((a, b) => {
      // Handle sorting by firstName
      if (key === 'firstName') {
        console.log("firstname")
        if (a.firstName && b.firstName) {
          return a.firstName.localeCompare(b.firstName);
        }
        return 0;
      }
  
      // Handle sorting by lastName
      if (key === 'lastName') {
        console.log("lastName")
        if (a.lastName && b.lastName) {
          return a.lastName.localeCompare(b.lastName);
        }
        return 0;
      }
        return 0;
    });
  
    // Update the state with the sorted contacts array
    console.log("sortedContacts",sortedContacts)
    setClientContacts(sortedContacts);
  };
  


  const exportCloudContacts= async()=>{
    try {
      beginLoading("Exporting contacts...", "Preparing your contact export now.");
      let apiResponse = await DEATH_API.exportCloudContacts();
      console.log("apiResponse", apiResponse);
      // if (apiResponse && apiResponse.status===200) {
      //  await getGroupContacts(selectedGroupIndex);
      // }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }

  }
  const addContactsToGroup= async()=>{
    console.log("Group Name:", selectedGroupIndex);
    const selectedIds = selectedRows.map(row => row.id);
    console.log(selectedIds);
    try {
      beginLoading("Updating group members...", "Please wait while we update the selected group.");
      let apiResponse = await DEATH_API.createGroupContacts({groupId:selectedGroupIndex ,contactIds:selectedIds});
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.status===200) {
       await getGroupContacts(selectedGroupIndex);
       await getContacts();
       await getGroups();
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }

    // setGroupName('');
    setSelectedRows([]);
    // setEditGroup(false);
  }
  const createGroup= async()=>{
    console.log("Group Name:", groupName);
    try {
      beginLoading("Creating group...", "Please wait while we create the new group.");
      let apiResponse = await DEATH_API.createGroup(groupName);
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.status===200) {
       await getGroups();
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }

    setGroupName('');
  }

  const updateGroupName=async()=>{
    console.log("Group Name:", groupName,selectedGroupIndex);
    try {
      beginLoading("Saving group changes...", "Please wait while we update the group name.");
      let apiResponse = await DEATH_API.updateGroup(selectedGroupIndex,groupName);
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.status===200) {
       await getGroups();
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }

  }
  const groupCols = [
    {
      title: 'Group Name',
      dataIndex: 'name',
    },
    {
      title: 'Group Members',
      dataIndex: 'count',
    },
    {
      title: 'Action',
      render: (record, index) => {
        return (
          <React.Fragment>
              <div style={{ display: "flex" }} key={index}>
                {" "}
                <img
                  style={{ cursor: "pointer", marginRight: "1rem" }}
                  src={menuIcon}
                  alt="menuIcon"
                  height={15}
                  width={4}
                  onClick={() => {
                    console.log("recode", record);
                    // getSelectedRow(record.id);
                    setSelectedGroupIndex(record.id);
                    setGroupName(record.name);
                    setGroupDropdown(!groupDropdown);
                  }}
                ></img>{" "}
                {groupDropdown && selectedGroupIndex === record.id && (
                  <React.Fragment>
                    <div
                      onClick={() => {
                        setGroupDropdown(false);
                      }}
                      className=""
                      style={{
                        position: "fixed",
                        width: "100vw",
                        height: "100vh",
                        background: "black",
                        opacity: "0.1",
                        top: "0",
                        left: "0",
                        right: "0",
                        bottom: "0",
                        zIndex: "999",
                      }}
                    ></div>

                    <div className="dropdown" style={{ zIndex: "9999" }}>
                      <ul className="dropdownul">
                        <li
                          className="liHover"
                          onClick={() => {
                            setGroupDropdown(false);
                            setEditGroup(true);
                            setAddGroup(false);
                            getGroupContacts(record.id)
                          }}
                        >
                          Edit
                        </li>

                        <li
                          className="liHover"
                          onClick={() => {
                            deleteGroup(record.id)
                            setGroupDropdown(false);
                          }}
                        >
                          Delete
                        </li>
                      </ul>
                    </div>
                  </React.Fragment>
                )}{" "}
              
              </div>
              
          </React.Fragment>
        );
      },
    },
  ];
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      sorter: (a, b) =>
        a.name > b.name ? 1 : a.name === b.name ? 0 : -1,
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: 'Phone',
      dataIndex: 'phoneNumber',
      sorter: (a, b) =>
        a.phoneNumber > b.phoneNumber ? 1 : a.phoneNumber === b.phoneNumber ? 0 : -1,
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      sorter: (a, b) =>
        a.email > b.email ? 1 : a.email === b.email ? 0 : -1,
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: 'Group',
      // dataIndex: 'groupId',
      sorter: (a, b) =>
        a.email > b.email ? 1 : a.email === b.email ? 0 : -1,
      render: (record) => {
        if(selectedRowKeys && allGroups && selectedRowKeys.groupId){
          if(selectedRowKeys.matchingIndexesPlusOne && selectedRowKeys.matchingIndexesPlusOne.includes(record.key)){
            const group = allGroups.find(i => i.id === selectedRowKeys.groupId)
            return group && group.name
          }else{return "N/A"}

        }else{return "N/A"}
      },
    },
  ];
  const rowSelection = {
    type: 'checkbox',
    selectedRowKeys:selectedRowKeys.matchingIndexesPlusOne,
    onChange: (selectedRowKeys, selectedRows) => {
      console.log('selectedRowKeys:', selectedRowKeys);
      console.log('selectedRows:', selectedRows);
      // setSelectedRowKeys(selectedRowKeys); // Update selectedRowKeys using functional update
      setSelectedRowKeys((prev)=> ({...prev, matchingIndexesPlusOne:selectedRowKeys}));
    },
    // getCheckboxProps: (record) => ({
    //   checked: selectedRowKeys.includes(String(record.key)), // Check if the record id is included in selectedRowKeys (convert id to string if necessary)
    // }),
  };
  const filteredContacts = clientContacts && clientContacts.filter((contact) =>
  contact.name && contact.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredGroupContacts = clientContacts && clientContacts.filter((contact) =>
    contact.name && contact.name.toLowerCase().includes(searchGroupContacts.toLowerCase())
  );
  const handleClose= async()=>{
  setAddGroup(false);
  setEditGroup(false);
  setEditContacts(false);
  setViewContacts(false);
  setImportContacts(false);
  setAddContact(false);
  await getContacts();
  await getGroups();

  }
  const handleCloseAddContact=()=>{
    setAddGroup(false);
    setEditGroup(false);
    setEditContacts(false);
    setViewContacts(false);
    setImportContacts(false);
    setAddContact(false);
    getContacts();
  
    }
  const handleCloseConnect = () => {
    setImportContacts(false);
    getContacts();
  };
 
  const deleteGroup = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this Group?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          beginLoading("Deleting group...", "Please wait while we remove this group.");
          await DEATH_API.deleteGroup(id);
          setLoading(false);
          getGroups();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Deleted!", "Your Group has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Group is safe :)", "error");
      }
    });
  };

  const saveGroupChanges = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Changes have not been saved. Are you sure you want to leave?",
      dangerMode: true,
      buttons: ["Leave", "Cancel"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        // try {
        //   setLoading(true);
        //   await DEATH_API.deleteGroup(id);
        //   setLoading(false);
        //   getGroups();
        // } catch (error) {
        //   console.log(error);
        //   setLoading(false);
        // }
        // setTimeout(async () => {
        //   swal("Deleted!", "Your Group has been deleted.", "success");
        // }, 0);
      } else {
        swal("Cancelled", "Your Changes are safe :)", "error");
      }
    });
  };
  
  const deleteCloudContact = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this Contact?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          beginLoading("Deleting contact...", "Please wait while we remove this contact.");
          await DEATH_API.deleteCloudContact(id);
          setLoading(false);
          await getContacts();
          await getGroups();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Deleted!", "Your Contact has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Contact is safe :)", "error");
      }
    });
  };
  const getGroups = async (options = {}) => {
    const { showLoader = true } = options;
    try {
      if (showLoader) {
        beginLoading("Loading groups...", "Fetching the latest groups for this client.");
      } else {
        setInitialGroupsLoading(true);
      }
      let apiResponse = await DEATH_API.getGroups();
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.groups) {
        setAllGroups(apiResponse.groups);
        
      }
    } catch (error) {
      console.log(error);
    } finally {
      if (showLoader) {
        setLoading(false);
      }
      setInitialGroupsLoading(false);
    }
  };
  const getGroupContacts = async (id) => {
    try {
      beginLoading("Loading group contacts...", "Fetching contacts assigned to this group.");
      let apiResponse = await DEATH_API.getGroupContacts(id);
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.contacts) {
        // Extracting only the cloud_contact objects from the contacts array
        const cloudContacts = apiResponse.contacts.map(contact => contact.cloud_contact).filter(Boolean);
        console.log("Cloud Contacts:", cloudContacts,clientContacts);
        // const matchingRows = clientContacts && clientContacts.filter((item) => {
        //   return cloudContacts.some((apiItem) => apiItem.phoneNumber === item.phoneNumber);
        // });
        const matchingIndexes = cloudContacts.map(apiItem => {
          const index = clientContacts.findIndex(item => item.phoneNumber === apiItem.phoneNumber);
          return index !== -1 ? index : null; // Return null if not found
        }).filter(index => index !== null);
      
        console.log("matchingIndexes:", matchingIndexes);
        const matchingIndexesPlusOne = matchingIndexes.map(index => index + 1);
        // const matchingIds = matchingRows.map((row) => (row.id));
        // console.log("matchingKeys", matchingIds);
        setSelectedRowKeys({matchingIndexesPlusOne:matchingIndexesPlusOne,groupId:id});
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  
  const getContacts = async (options = {}) => {
    const { showLoader = true } = options;
    try {
      if (showLoader) {
        beginLoading("Loading contacts...", "Fetching the latest contacts for this client.");
      } else {
        setInitialContactsLoading(true);
      }
      setClientContacts([])
      let apiResponse = await DEATH_API.getClientContacts();
      console.log("apiResponse 22", apiResponse);
      if (apiResponse && apiResponse.data) {
        const apiData = apiResponse.data.map((item, index) => {
          let fullName = null;
      
          if (item.name && item.name.trim() !== "") {
            fullName = item.name.trim();
          } else {
            if (item.firstName && item.firstName.trim() !== "" && item.lastName && item.lastName.trim() !== "") {
              fullName = item.firstName.trim() + " " + item.lastName.trim();
            }
          }
      
          // Add key with index + 1 value
          const newItem = { ...item, name: fullName, };
          return newItem;
        });
        const filteredApiData = apiData.filter((item) => item.name !== null && item.name !== '');
        const filteredApiDataWithKeys = filteredApiData.map((item, index) => ({
          ...item,
          key: index + 1
          }));
        setClientContacts(filteredApiDataWithKeys);
        console.log("apidata22", filteredApiDataWithKeys,filteredApiData)
      }
      // if (apiResponse && apiResponse.data) {
      //   const apiData = apiResponse.data.map((item, index) => {
      //     let fullName = "";
      //     if (item.firstName && item.firstName.trim() !== "") {
      //       fullName += item.firstName.trim();
      //     }
      //     if (item.lastName && item.lastName.trim() !== "") {
      //       fullName += " " + item.lastName.trim();
      //     }
      //     // If fullName is still empty, set it to null
      //     fullName = fullName.trim() !== "" ? fullName.trim() : null;
      
      //     // Concatenate firstName and lastName if name is null or empty
      //     if (!item.name || item.name.trim() === '') {
      //       return { ...item, name: fullName };
      //     } else {
      //       return item;
      //     }
      //   });
      //   const filteredApiData = apiData.filter((item) => item.name !== null && item.name !== '');
      //   setClientContacts(filteredApiData);
      // }
    } catch (error) {
      console.log(error);
    } finally {
      if (showLoader) {
        setLoading(false);
      }
      setInitialContactsLoading(false);
    }
  };
  
  // const getContacts = async () => {
  //   try {
  //     setLoading(true);
  //     let data = await DEATH_API.getClientContacts();
  //     console.log("datares",data);
  //     if(data && data.data){

  //       setClientContacts(data.data)
  //       const matchingRows = data.data.filter((item) => {
  //         return data.some((apiItem) => apiItem.phoneNumber === item.phoneNumber);
  //       });
  //       setSelectedRowKeys(matchingRows);
  //     console.log("matchingKeys",matchingRows)
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     console.log(error);
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    // Check if the URL contains the authorization code
    getContacts({ showLoader: false });
    getGroups({ showLoader: false });
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    if (code) {
      handleAppleResponse({ authorization: code });
    }
  }, []);

  const handleAppleResponse = async (response) => {
    console.log("response", response);
    try {
      beginLoading("Importing Apple contacts...", "Please wait while we connect and load your Apple contacts.");
      // Extract the authorization code from the response
      const { authorization } = response;
      // Make a request to your server to exchange the authorization code for tokens
      const tokenResponse = await axios.post("/apple/token", { authorization });
      // Extract the access token from the response
      const { access_token } = tokenResponse.data;
      // Make a request to fetch contacts using the access token
      const contactsResponse = await axios.get(`/apple/contacts`, {
        headers: { Authorization: `Bearer ${access_token}` },
      });
      // Handle the response containing contacts
      console.log("Contacts:", contactsResponse.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching contacts:", error);
      setLoading(false);
    }
  };

  const showContactsSkeleton = initialContactsLoading && clientContacts.length === 0;
  const showGroupsSkeleton = initialGroupsLoading && allGroups.length === 0;
  const contactsHeaderMenu = (
    <Menu>
      <Menu.Item disabled>
        <div>Sort By</div>
      </Menu.Item>
      <Menu.Item
        disabled={!clientContacts || clientContacts.length === 0}
        onClick={() => {
          sortBy("firstName");
        }}
      >
        <div>Sort By First Name</div>
      </Menu.Item>
      <Menu.Item
        disabled={!clientContacts || clientContacts.length === 0}
        onClick={() => {
          sortBy("lastName");
        }}
      >
        <div>Sort By Last Name</div>
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          console.log("here in import");
          if(groupNameEdit && groupNameEdit!==""){
            swal({
              title: "Are you sure?",
              text: "Changes have not been saved. Are you sure you want to leave?",
              dangerMode: true,
              buttons: ["Leave", "Cancel"],
              icon: "warning",
              type: "warning",
              closeOnConfirm: false,
              closeOnCancel: false,
            }).then(function (isConfirm) {
              if (isConfirm) {
                setAddContact(false);
                setImportContacts(true);
                setViewContacts(false);
                setEditContacts(false);
                setAddGroup(false);
                setEditGroup(false);
                setGroupNameEdit("");
              } else {
                swal("Cancelled", "Your Changes are safe :)", "error");
              }
            });
          }else{
            setAddContact(false);
            setImportContacts(true);
            setViewContacts(false);
            setEditContacts(false);
            setAddGroup(false);
            setEditGroup(false);
          }
        }}
      >
        <div>Import Contacts</div>
      </Menu.Item>
      <Menu.Item
        disabled={!clientContacts || clientContacts.length === 0}
        onClick={() => {
          downloadCSV();
        }}
      >
        <div>Export Contacts</div>
      </Menu.Item>
    </Menu>
  );



  return (
    <div>
      <div className="clientPlanLayout clientPlanSectionShell" style={{ display: "flex", justifyContent: "space-between", padding:"1rem" }}>
        <div className="chatMain">
        <ModalVideo module="Client Contacts" autoOpen={true} />
          {/*<div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              marginBottom: "1rem",
            }}
          >
            <img
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "80%",
              }}
              src={logo}
              className=""
            />
            </div> */}
          <div className="sidebarSectionHeader" style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="sidebarTitleGroup">
              <h3 className="contactsSubHeading">Contacts</h3>
            </div>
            <div className="addButtonContainer">
              <div className="addButtonContact" title="Add Contact" onClick={()=>{
                if(groupNameEdit && groupNameEdit!==""){
                  swal({
                    title: "Are you sure?",
                    text: "Changes have not been saved. Are you sure you want to leave?",
                    dangerMode: true,
                    buttons: ["Leave", "Cancel"],
                    icon: "warning",
                    type: "warning",
                    closeOnConfirm: false,
                    closeOnCancel: false,
                  }).then(function (isConfirm) {
                    // Redirect the user
                    if (isConfirm) {
                      setAddContact(true);
                      setAddGroup(false);
                      setEditContacts(false);
                      setViewContacts(false);
                      setImportContacts(false);
                      setEditGroup(false);
                      setGroupNameEdit("");
                    } else {
                      swal("Cancelled", "Your Changes are safe :)", "error");
                    }
                  });
                }else{
                  setAddContact(true);
                  setAddGroup(false);
                  setEditContacts(false);
                  setViewContacts(false);
                  setImportContacts(false);
                  setEditGroup(false);
                }

              }}>+</div>
              <div
                className="sidebarIconButton"
                onClick={()=>{
                  if(groupNameEdit && groupNameEdit!==""){
                    swal({
                      title: "Are you sure?",
                      text: "Changes have not been saved. Are you sure you want to leave?",
                      dangerMode: true,
                      buttons: ["Leave", "Cancel"],
                      icon: "warning",
                      type: "warning",
                      closeOnConfirm: false,
                      closeOnCancel: false,
                    }).then(function (isConfirm) {
                      // Redirect the user
                      if (isConfirm) {
                        setAddGroup(true);
                        setEditGroup(false);
                        setGroupName('');
                        setViewContacts(false);
                        setEditContacts(false);
                        setImportContacts(false); 
                        setAddContact(false);
                        getGroups();
                        setGroupNameEdit("");
                      } else {
                        swal("Cancelled", "Your Changes are safe :)", "error");
                      }
                    });
                  }else{
                    setAddGroup(true);
                    setEditGroup(false);
                    setGroupName('');
                    setViewContacts(false);
                    setEditContacts(false);
                    setImportContacts(false); 
                    setAddContact(false);
                    getGroups();
                  }

                  }}
              >
                <img className="sidebarHeaderIcon sidebarHeaderIconTag" src={tag} alt="tag" />
              </div>
              <Dropdown trigger={["click"]} overlay={contactsHeaderMenu} overlayClassName="contactsHeaderDropdown">
                <div className="sidebarIconButton sidebarMenuButton">
                  <img
                    className="sidebarHeaderIcon sidebarHeaderIconMenu"
                    src={menuIcon}
                    alt="menuIcon"
                  />
                </div>
              </Dropdown>
            </div>
          </div>
          {!showContactsSkeleton && (
            <React.Fragment>
              <div className="sidebarSearchWrap" style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                <input
                  className="searchStyle"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
              <div className="sidebarUtilityRow" style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
              {filteredContacts && filteredContacts.length>0 &&
              <label className="sidebarSelectAll" style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                  style={{ display: "none" }}
                />
                <span
                  style={{
                    display: "inline-block",
                    width: "16px",
                    height: "16px",
                    marginRight: "8px",
                    border: "1px solid #2A3DA3",
                    backgroundColor: selectAll ? "#2A3DA3" : "#FFF",
                    borderRadius: "3px",
                    textAlign: "center",
                    lineHeight: "16px",
                    fontSize: "14px",
                    color: "white"
                  }}
                >
                  {selectAll ? "✔" : ""}
                </span>
                Select All
              </label>
                }
              {selectedCheckContacts && selectedCheckContacts.length>0 &&
              <div>  
              <img
              className="sidebarSettingsIcon"
              onClick={() => {
                openModal();
              }}
              src={setting}
              height={32}
              width={32}>
              </img>
              </div>
              }
              </div>
            </React.Fragment>
          )}
          <div className="contactsCol" style={{position:"relative"}}>
            {showContactsSkeleton ? (
              <SidebarListSkeleton rows={6} />
            ) : filteredContacts && filteredContacts.length>0 ?
              filteredContacts.map((item, index) => (
                <div
                  key={index}
                  className="chatCardInner"
                  // style={{position:"relative"}}
                  onMouseEnter={() => setSelectedContact(item.id)}
                  onMouseLeave={() => setSelectedContact(null)}
                >
                  {" "}
                  <div className="chatCard" style={{flexWrap:"nowrap"}} 
                  onClick={() => {
                    if(groupNameEdit && groupNameEdit!==""){
                      swal({
                        title: "Are you sure?",
                        text: "Changes have not been saved. Are you sure you want to leave?",
                        dangerMode: true,
                        buttons: ["Leave", "Cancel"],
                        icon: "warning",
                        type: "warning",
                        closeOnConfirm: false,
                        closeOnCancel: false,
                      }).then(function (isConfirm) {
                        // Redirect the user
                        if (isConfirm) {
                          setViewContacts(true);
                          setEditContacts(false)
                          setContactDropdown(false);
                          setImportContacts(false);
                          setManageContact(item);
                          setAddGroup(false);
                          setEditGroup(false);
                          setAddContact(false);
                          setGroupNameEdit("");
                        } else {
                          swal("Cancelled", "Your Changes are safe :)", "error");
                        }
                      });
                    }else{
                      setViewContacts(true);
                      setEditContacts(false)
                      setContactDropdown(false);
                      setImportContacts(false);
                      setManageContact(item);
                      setAddGroup(false);
                      setEditGroup(false);
                      setAddContact(false);
                    }
                    
                  }}>
                    {item.image ? (
                      <div style={{ borderRadius: "50%" }}>
                        <img
                          src={item.image}
                          height={"48px"}
                          width={"48px"}
                          alt={"new"}
                          style={{ borderRadius: "1rem" }}
                        />
                      </div>
                    ) : (
                      <div className="contactLogo">
                        {/* item.name.charAt(0).toUpperCase() */}
                        {item.name
                          ? item.name
                              .split(" ")
                              .map((part) => part[0])
                              .join("")
                          : "N/A"}
                      </div>
                    )}{" "}
                    <div className="chatCardDesc">
                      <span className="chatName">
                        {item.name}
                      </span>
                      <span className="chatValue" style={{}}>
                        {item.phoneNumber}
                      </span>
                    </div>
                  </div>
                 {selectedContact === item.id &&
                  <Dropdown overlay={
                    <Menu>
                      <Menu.Item>
                        <div  onClick={() => {
                          //   deleteSelectedRow(record.id);
                          if(groupNameEdit && groupNameEdit!==""){
                            swal({
                              title: "Are you sure?",
                              text: "Changes have not been saved. Are you sure you want to leave?",
                              dangerMode: true,
                              buttons: ["Leave", "Cancel"],
                              icon: "warning",
                              type: "warning",
                              closeOnConfirm: false,
                              closeOnCancel: false,
                            }).then(function (isConfirm) {
                              // Redirect the user
                              if (isConfirm) {
                                setViewContacts(true);
                                setEditContacts(false)
                                setContactDropdown(false);
                                setImportContacts(false);
                                setManageContact(item);
                                setAddGroup(false);
                                setEditGroup(false);
                                setAddContact(false);
                                setGroupNameEdit("");
                              } else {
                                swal("Cancelled", "Your Changes are safe :)", "error");
                              }
                            });
                          }else{
                            setViewContacts(true);
                            setEditContacts(false)
                            setContactDropdown(false);
                            setImportContacts(false);
                            setManageContact(item);
                            setAddGroup(false);
                            setEditGroup(false);
                            setAddContact(false);
                          }
                          
                        }}>
                          Edit
                        </div>
                      </Menu.Item>
                      <Menu.Item>
                        <div   onClick={() => {
                          //   deleteSelectedRow(record.id);
                          deleteCloudContact(item.id)
                          setEditContacts(false);
                          setAddContact(false);
                          setViewContacts(false);
                        }}>
                          Delete
                        </div>
                      </Menu.Item>
                     
                    </Menu>
                  }
                  // visible={contactdropdown} // Manage visibility with state
                  // trigger={['click']}
                  
                  >
                  
                  <a className="ant-dropdown-link sidebarMenuLink" onClick={e => e.preventDefault()}>
                  <img
                  className="sidebarDotsIcon"
                  src={menuIcon}
                  alt="time"
                  onClick={() => {
                    setContactDropdown(!contactdropdown);
                  }}
                />
                  </a>
                </Dropdown>
                 }
                 { /*<input
                  type="checkbox"
                  checked={selectedContacts.includes(item.id)}
                  onChange={() => handleCheckboxChange(item.id)}
                        /> */}
                        <label style={{ display: "flex", alignItems:"center", cursor: "pointer", marginBottom:"0px" }}>
                        <input
                          type="checkbox"
                          style={{ display: "none" }}
                          checked={selectedCheckContacts.includes(item.id)}
                          onChange={() => handleCheckboxChange(item.id)}
                        />
                        <span
                          style={{
                            display: "inline-block",
                            width: "16px",
                            height: "16px",
                            marginRight: "12px",
                            border: "1px solid #2A3DA3",
                            backgroundColor: selectedCheckContacts.includes(item.id) ? "#2A3DA3" : "#FFF", // Change background color here
                            borderRadius: "3px",
                            textAlign: "center", // Center the tick horizontally and vertically
                            lineHeight: "16px", // Align the tick vertically
                            fontSize: "14px", // Adjust the font size as needed
                            color:"white"
                          }}
                        >
                          {selectedCheckContacts.includes(item.id) ? "✔" : ""}
                        </span>
                        {item.label}
                      </label>
                </div>
              ))
              :<div className="noDataToShow sidebarEmptyState" style={{textAlign:"center"}}>No Contacts To show</div>
            }
          </div>
          <div className="sidebarSectionHeader" style={{ display: "flex", justifyContent: "space-between", marginTop:"1rem" }}>
          <div className="sidebarTitleGroup" style={{display:'flex', alignItems: "baseline", justifyContent: 'center', columnGap:'3px'}}>
            <h3 className="contactsSubHeading">Groups</h3>
            <ToolTipCreator name="Contacts_Groups"/>
          </div>
            <div className="addButtonContact" title="Add Group" onClick={()=>{

              if(groupNameEdit && groupNameEdit!==""){
                swal({
                  title: "Are you sure?",
                  text: "Changes have not been saved. Are you sure you want to leave?",
                  dangerMode: true,
                  buttons: ["Leave", "Cancel"],
                  icon: "warning",
                  type: "warning",
                  closeOnConfirm: false,
                  closeOnCancel: false,
                }).then(function (isConfirm) {
                  // Redirect the user
                  if (isConfirm) {
                    setAddGroup(true);
                    setEditGroup(false);
                    setGroupName('');
                    setViewContacts(false); 
                    setEditContacts(false);
                    setImportContacts(false);
                    setAddContact(false);
                    getGroups();
                    setGroupNameEdit("");
                  } else {
                    swal("Cancelled", "Your Changes are safe :)", "error");
                  }
                });
              }else{
                setAddGroup(true);
                setEditGroup(false);
                setGroupName('');
                setViewContacts(false); 
                setEditContacts(false);
                setImportContacts(false);
                setAddContact(false);
                getGroups();
              }
            }}>+</div>
          </div>
          <div className="groupsCol" style={{position:"relative"}}>
            {showGroupsSkeleton ? (
              <SidebarListSkeleton rows={4} showSearch={false} compact />
            ) : allGroups && allGroups.length>0 ?
              allGroups.map((item, index) => (
                <div key={index} className="chatCardInner" >
                  {" "}
                  <div className="chatCard" style={{flexWrap:"nowrap"}} onClick={()=>{
                    if(groupNameEdit && groupNameEdit!==""){
                      swal({
                        title: "Are you sure?",
                        text: "Changes have not been saved. Are you sure you want to leave?",
                        dangerMode: true,
                        buttons: ["Leave", "Cancel"],
                        icon: "warning",
                        type: "warning",
                        closeOnConfirm: false,
                        closeOnCancel: false,
                      }).then(function (isConfirm) {
                        // Redirect the user
                        if (isConfirm) {
                          setEditGroup(true);
                          setAddGroup(false);
                          setAddContact(false);
                          setImportContacts(false);
                          setViewContacts(false);
                          setEditContacts(false);
                          setGroupName(item.name);
                          setSelectedGroupIndex(item.id);
                          getGroupContacts(item.id)
                          setGroupNameEdit("");
                        } else {
                          swal("Cancelled", "Your Changes are safe :)", "error");
                        }
                      });
                    }else{
                      setEditGroup(true);
                      setAddGroup(false);
                      setAddContact(false);
                      setImportContacts(false);
                      setViewContacts(false);
                      setEditContacts(false);
                      setGroupName(item.name);
                      setSelectedGroupIndex(item.id);
                      getGroupContacts(item.id)
                    }

                  }}>
                    {item.image ? (
                      <div style={{ borderRadius: "50%" }}>
                        <img
                          src={item.image}
                          height={"48px"}
                          width={"48px"}
                          alt={"new"}
                          style={{ borderRadius: "1rem" }}
                        />
                      </div>
                    ) : (
                      <div className="contactLogo">
                        {/* item.name.charAt(0).toUpperCase() */}
                        {item.name
                          ? item.name
                              .split(" ")
                              .map((part) => part[0])
                              .join("")
                          : "N/A"}
                      </div>
                    )}{" "}
                    <div className="chatCardDesc">
                      <span className="chatName">
                        {item.name}
                      </span>
                      <span className="chatValue" style={{}}>
                        {item.count} Participant
                      </span>
                    </div>
                  </div>
                  <div className="contactsDelete">
                     <Dropdown trigger={["click"]} overlay={
                      <Menu>
                        <Menu.Item>
                          <div onClick={()=>{
                            if(groupNameEdit && groupNameEdit!==""){
                              swal({
                                title: "Are you sure?",
                                text: "Changes have not been saved. Are you sure you want to leave?",
                                dangerMode: true,
                                buttons: ["Leave", "Cancel"],
                                icon: "warning",
                                type: "warning",
                                closeOnConfirm: false,
                                closeOnCancel: false,
                              }).then(function (isConfirm) {
                                // Redirect the user
                                if (isConfirm) {
                                  setEditGroup(true);
                                  setAddGroup(false);
                                  setAddContact(false);
                                  setImportContacts(false);
                                  setViewContacts(false);
                                  setEditContacts(false);
                                  setGroupName(item.name);
                                  setSelectedGroupIndex(item.id);
                                  getGroupContacts(item.id)
                                  setGroupNameEdit("");
                                } else {
                                  swal("Cancelled", "Your Changes are safe :)", "error");
                                }
                              });
                            }else{
                              setEditGroup(true);
                              setAddGroup(false);
                              setAddContact(false);
                              setImportContacts(false);
                              setViewContacts(false);
                              setEditContacts(false);
                              setGroupName(item.name);
                              setSelectedGroupIndex(item.id);
                              getGroupContacts(item.id)
                            }

                          }}>
                            Edit
                          </div>
                        </Menu.Item>
                        <Menu.Item>
                          <div   onClick={() => {
                            deleteGroup(item.id)
                            setEditGroup(false);
                          }}>
                            Delete
                          </div>
                        </Menu.Item>
                       
                      </Menu>
                    }                 
                    >
                    
                    <a className="ant-dropdown-link sidebarMenuLink" onClick={e => e.preventDefault()}>
                    <img
                    className="sidebarDotsIcon"
                    src={menuIcon}
                    alt="time"
                    onClick={() => {
                      // setContactDropdown(!contactdropdown);
                    }}
                  />
                    </a>
                  </Dropdown>
                {/*  <img src={closeimg} height={"15px"} alt={"new"} />
                */}{" "}
                  </div>
                </div>
              ))
              :
              <div className="noDataToShow sidebarEmptyState" style={{textAlign:"center"}}>No Group To show</div>
            }
          </div>
        </div>
        <div style={{ width: "70%" }}>
          <div style={{ padding: "1rem" }}>
          {addGroup &&
            <div  style={{
              background: "white",
              padding: "1rem",
              marginTop: "1rem",
            }}>
            <div className="infocardrowData">
            <span
              className="infocardTitle1"
              style={{
                color: "black",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              {" "}
              Groups{" "}
            </span>
            <span className="infocardsubTitle">
              <label
                className="labelStyleCheckout"
                style={{
                  display: "inline-grid",
                  width: "100%",
                  marginTop: "4px",
                }}
              >
                <h3
                  style={{
                    marginBottom: "10px",
                    fontSize: "14px",
                    fontFamily: "Poppins",
                    lineHeight: "20px",
                    fontWeight: "700",
                  }}
                >
                  {" "}
                  Add New Group{" "}
                </h3>
                <div
                  className="inputStyleCheckoutPromo"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  <input
                    name="groupName"
                    placeholder="Enter Group"
                    className="inputStylepromo"
                    style={{ width: "100%" }}
                    value={groupName && groupName}
                    onChange={(e)=>{
                    console.log("value", e.target.value)
                    setGroupName(e.target.value);
                    }}
                  />
                  <button
                    className="savebutton"
                    onClick={()=>{
                      createGroup();
                    }}
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      fontWeight: "600",
                      padding: "10px 10px",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      opacity:groupName && groupName ? "1" :"0.5", 
                      pointerEvents:groupName && groupName ? "" : "none",
                    }}
                    type="submit"
                  >
                    Add
                  </button>
                </div>
                
              </label>
            </span>
          </div>
          <h3
          style={{
            marginBottom: "10px",
            fontSize: "14px",
            fontFamily: "Poppins",
            lineHeight: "20px",
            fontWeight: "700",
          }}
        >
          {" "}
          All Groups{" "}
        </h3>
          <Table columns={groupCols} dataSource={allGroups && allGroups} 
           pagination={{
            showSizeChanger: true, // Show the page size changer
            pageSizeOptions: ['10', '20', '50', '100'], // Options for page size
            defaultPageSize: 10, // Default page size
          }} />
          </div>
          }
          {editGroup &&
            <div className="clientPlanDetailPanel clientPlanGroupEditor">
            <div className="clientPlanGroupEditorHeader">
            <span
              className="infocardTitle1"
              style={{
                color: "black",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              {" "}
              Group{" "}
            </span>
            <div className="clientPlanGroupEditorForm">
              <label
                className="labelStyleCheckout"
                style={{
                  display: "inline-grid",
                  width: "100%",
                  marginTop: "4px",
                }}
              >
                <h3
                  style={{
                    marginBottom: "10px",
                    fontSize: "14px",
                    fontFamily: "Poppins",
                    lineHeight: "20px",
                    fontWeight: "700",
                  }}
                >
                  {" "}
                  Edit Group{" "}
                </h3>
                <div
                  className="inputStyleCheckoutPromo clientPlanGroupEditorFields"
                >
                <input
                  name="name"
                  placeholder="Enter Group"
                  className="inputStylepromo clientPlanGroupNameInput"
                  value={groupName && groupName}
                  onChange={(e)=>{
                    setGroupName(e.target.value);
                    setGroupNameEdit(e.target.value);
                  }}
                />
                {/*<button className="savebutton" onClick={()=>{updateGroupName()}} style={{width:"42px"}}>
                <div style={{display: "flex", justifyContent: "center", alignItems: "center", marginLeft: "4px"}}>
                <img src={penIcon} style={{height: "20px", width: "20px", marginRight: "4px", marginBottom: "4px"}} alt="penImage"/>
                </div>
                </button> */}
                <button
                  className="savebutton"
                  onClick={()=>{updateGroupName()}}
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    fontWeight: "600",
                    padding: "10px 10px",
                    width: "fit-content",
                    display: "flex",
                    alignItems: "center",
                    opacity:groupNameEdit && groupNameEdit ? "1" :"0.5", 
                    pointerEvents:groupNameEdit && groupNameEdit ? "" : "none",
                  }}
                  type="submit"
                >
                  Save Changes
                </button> 
                </div>
              </label>
            </div>
          </div>
          <div className="clientPlanGroupEditorToolbar">
          <div style={{display:"flex",justifyContent:"space-between", gap:"1rem"}}>
          {/* <button
          className="savebutton"
          onClick={()=>{
            setAddEmailTemplate(true);
          }}
          style={{
            textAlign: "center",
            fontSize: "12px",
            fontWeight: "600",
            padding: "10px 10px",
            width: "150px",
            display: "flex",
            alignItems: "center",
          }}
          type="submit"
        >
          Send Emails
        </button>
        <button
          className="savebutton"
          onClick={()=>{
            setAddTextTemplate(true);
          }}
          style={{
            textAlign: "center",
            fontSize: "12px",
            fontWeight: "600",
            padding: "10px 10px",
            width: "150px",
            display: "flex",
            alignItems: "center",
          }}
          type="submit"
        >
          Send Texts
        </button> */}
        </div>
        <div className="clientPlanGroupEditorActions">
        <input
          className="clientPlanGroupSearchInput"
          placeholder="Search"
          value={searchGroupContacts}
          onChange={(e) => setSearchGroupContacts(e.target.value)}
        />
          <button
          className="savebutton"
          onClick={()=>{

            addContactsToGroup();
          }}
          style={{
            textAlign: "center",
            fontSize: "12px",
            fontWeight: "600",
            padding: "10px 10px",
            width: "155px",
            display: "flex",
            alignItems: "baseline",
            columnGap:'3px'
          }}
          type="submit"
        >
        Update Group
        <ToolTipCreator name="Contacts_Update_Groups" iconWhite={true} />
        </button>
        </div>
        </div>
          <div className="clientPlanGroupTableWrap">
          <Table 
          // rowSelection={rowSelection}
          rowSelection={{
            type: 'checkbox',
            selectedRowKeys: selectedRowKeys.matchingIndexesPlusOne,
            onChange: (selectedRowKeys, selectedRows) => {
              console.log('selectedRowKeys:', selectedRowKeys);
              console.log('selectedRows:', selectedRows);
              
              // setSelectedRowKeys(selectedRowKeys);
              setSelectedRowKeys((prev)=> ({...prev, matchingIndexesPlusOne:selectedRowKeys}));
              setSelectedRows(selectedRows);
            },
          }}
          columns={columns} dataSource={filteredGroupContacts && filteredGroupContacts}
          pagination={{
            showSizeChanger: true, // Show the page size changer
            pageSizeOptions: ['10', '20', '50', '100'], // Options for page size
            defaultPageSize: 10, // Default page size
          }}
           />
           </div>
          </div>
          }
            {importContacts && <ConnectAccount close={handleCloseConnect} />}
            {/* View Contacts */}
            {viewContacts && (
              <ViewClientContacts editContacts={(state) => setEditContacts(state)} viewContacts={(state) => setViewContacts(state)}  contact={manageContact && manageContact} />
            )}

            {/* Update contacts */}
            {editContacts && <UpdateClinetContacts contact={manageContact && manageContact} close={handleClose} groups={allGroups} />}
           {addContact && <AddContacts close={handleCloseAddContact} groups={allGroups} /> }
          </div>
          <div></div>
        </div>
        {location.state && location.state.from && location.state.from === "/protector/disability" && 
        <button
            className="savebutton"
            style={{height:"fit-content"}}
            onClick={() => {
              dispatch(setActiveStep(1));
              history.goBack();
            }}
            
          >
            Cancel 
          </button>
        }
        {loading && (
          <div className="clientPlanSectionLoadingOverlay">
            <div className="clientPlanSectionLoadingCard">
              <div className="clientPlanFormSpinner" />
              <div className="clientPlanFormLoadingText">{loadingContent.title}</div>
              <div className="clientPlanFormLoadingSubtext">{loadingContent.subtext}</div>
            </div>
          </div>
        )}
      </div>
      <Modal
      visible={isModalOpen}
      footer={null}
      onOk={closeModal}
      onCancel={openModal}
      closable={false}
      centered
    >
      <h3 className="modaltitle">Contacts</h3>
      <h3 className="modaltitle" >
      {selectedCheckContacts && selectedCheckContacts.length} Contacts Selected
      </h3>
      <div className="buttonsMain" style={{justifyContent:"center", flexDirection:"column"}}>
      <button
      className="savebutton"
      onClick={() => {
        downloadSelectedCSV();
        closeModal();
      }}
      
    >
      Export 
    </button>
    <button
      className="savebutton"
      onClick={() => {
        deleteSelectCloudContact();
        closeModal();
      }}
      
    >
      Delete
    </button>
        <button
          className="cancelbutton"
          onClick={() => {
            closeModal();
          }}
        >
          Cancel
        </button>
      </div>
    </Modal>
    {addEmailTemplate && (
    <Modal
          centered
          visible={addEmailTemplate}
          footer={null}
          closable={false}
          onCancel={false}
        >
          <h3> Email To Send</h3>
          <div style={{}}>
          <h3
          style={{
           color: "#4d5e80",
            marginBottom: "10px",
             fontSize: "14px",
             fontFamily: "Poppins",
             lineHeight: "20px",
             fontWeight: "700",
              }}
              >
               {" "}
               Subject{" "}
              </h3>
            <input
              id="name"
              type="text"
              placeholder="Subject"
              name="subject"
              className="inputStylepromo"
              style={{marginBottom:"1rem", width:"100%"}}
              onChange={(e) => {
                e.persist();
                console.log("eevnt value", e.target.value);
                setEmailTemplateData((prevFormData) => ({
                  ...prevFormData,
                  subject: e.target.value,
                }));
              }}
            />
            <ReactQuill
              id="template"
              placeholder="Type Email"
              name="email"
              onChange={(e) => {
                // e.persist();
                setEmailTemplateData((prevFormData) => ({
                  ...prevFormData,
                  emailBody: e,
                }));
              }}
            ></ReactQuill>
          </div>
          <div style={{display:"flex", justifyContent:"space-between", marginTop:"1rem", gap:"1rem"}}>
            <button className="cancelbutton" onClick={closeEmailTemplateModal}>
              Cancel
            </button>
            <button id="stop" className="savebutton" onClick={saveEmailTemplateModal}>
              Send
            </button>
          </div>
    </Modal>
    )}
    {addTextTemplate && (
        <Modal
          centered
          visible={addTextTemplate}
          footer={null}
          closable={false}
          onCancel={false}
        >
          <h3>Text To Send</h3>
          <div style={{}}>
          <h3
          style={{
           color: "#4d5e80",
            marginBottom: "10px",
             fontSize: "14px",
             fontFamily: "Poppins",
             lineHeight: "20px",
             fontWeight: "700",
              }}
              >
               {" "}
               Text{" "}
              </h3>
            <ReactQuill
              id="template"
              placeholder="Template"
              name="template"
              modules={{ toolbar: false }}
              onChange={(e) => {
                // e.persist();
                setTextTemplateData((prevFormData) => ({
                  ...prevFormData,
                  textBody: e,
                }));
              }}
            ></ReactQuill>
          </div>
          <div style={{display:"flex", justifyContent:"space-between", marginTop:"1rem", gap:"1rem"}}>
            <button className="cancelbutton" onClick={closeTextTemplateModal}>
              Cancel
            </button>
            <button className="savebutton" id="stop" onClick={saveTextTemplateModal}>
              Send
            </button>
          </div>
        </Modal>
    )}
    </div>
  );
};
